import { render, staticRenderFns } from "./information-apply.vue?vue&type=template&id=fc896270&scoped=true"
import script from "./information-apply.vue?vue&type=script&lang=js"
export * from "./information-apply.vue?vue&type=script&lang=js"
import style0 from "./information-apply.vue?vue&type=style&index=0&id=fc896270&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc896270",
  null
  
)

export default component.exports